import * as Yup from "yup";

export const employeeFeedbackSchema = Yup.object().shape({
  feedbackType: Yup.string().required("This Field is required"),
  feedback: Yup.string().required("This Field is required"),
  markAsRead: Yup.boolean(),
});
